module.exports = __webpack_public_path__ + "img/towel.fca40259.svg";